export function checkStringMultipleIncludes(mainString: string, values: Array<string>): boolean {
  return values.some((substr) => mainString.includes(substr));
}
